module.exports = __webpack_public_path__ + "img/tour-wireframe.88e9cc92.svg";